import React from 'react';
import './ContactPage.css';

const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits.length === 2 ? `(${digits}) ` : digits ? `(${digits}` : '';
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

const ContactPage = () => {
  const handlePhoneChange = (e) => {
    e.target.value = formatPhone(e.target.value);
  };

  return (
    <div className="contact-page-container">
      <h2>Fale Conosco</h2>
      <p>Envie suas dúvidas, sugestões ou entre em contato para mais informações sobre nossos produtos.</p>

      <div className="contact-content">
        {/* Formulário de Contato */}
        <div className="contact-form-section">
          <h3>Envie uma Mensagem</h3>
          <form className="contact-form" name="contact" method="POST" data-netlify="true" action="/success">
            <input type="hidden" name="form-name" value="contact" />
            
            <div className="form-group">
              <label htmlFor="name">Nome:</label>
              <input type="text" id="name" name="name" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">E-mail:</label>
              <input type="email" id="email" name="email" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone">Celular:</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="(41) 99999-9999"
                pattern="^\(\d{2}\) 9\d{4}-\d{4}$"
                title="Digite um celular válido: (XX) 9XXXX-XXXX"
                onInput={handlePhoneChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Mensagem:</label>
              <textarea id="message" name="message" rows="6" required></textarea>
            </div>
            
            <button type="submit" className="submit-button">Enviar Mensagem</button>
          </form>
        </div>

        {/* Informações de Contato Adicionais */}
        <div className="contact-info-section">
          <h3>Nossos Contatos</h3>
          <p>Se preferir, entre em contato pelos canais abaixo:</p>
          <div className="contact-details">
            <p><strong>E-mail:</strong> contato@dallazuana.com</p>
            <p>
              <strong>Telefone / WhatsApp:</strong>{' '}
              <a
                href="https://wa.me/5541998443944"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-whatsapp-link"
              >
                (41) 99844-3944
              </a>
            </p>
            <p><strong>Endereço:</strong> Pinheirinho, Curitiba/PR</p>
            <p><strong>Horário de Atendimento:</strong> Seg-Sex: 9h-18h</p>
          </div>

          {/* Ícones de Redes Sociais */}
          <div className="social-media-links">
            <h3>Siga-nos:</h3>
            <a href="https://instagram.com/donaempadinha_" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <img src="https://img.icons8.com/ios-filled/50/007bff/instagram-new.png" alt="Instagram" />
            </a>
            <p>Instagran</p>
            {/* Adicione mais ícones conforme necessário */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;